/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import { summaryDrawerOpen } from '../../../analytics';

export default (
  set,
  get,
  feature,
  name = 'stack builder',
  modalTrackingOptions = {}
) => set(produce(get(), (draft) => {
  if (!draft.digitalData) {
    draft.digitalData = { event: [] };
  }

  const trackModalLinkClick = {
    feature,
    name,
    modalTrackingOptions,
  };

  draft.digitalData.modalLinkClick = trackModalLinkClick;

  summaryDrawerOpen(trackModalLinkClick);

}), false, { type: 'TRACK_MODAL_LINK_CLICK' });
